<header [class]="{ scrolled: isScrolled }">
  <div class="container">
    <div class="d-flex justify-content-between p-3">
      <img src="assets/images/logo.png" alt="logo" class="logo-img" />
      <div class="menus d-none d-lg-flex gap-4 align-items-center">
        @for (menu of menus; track $index) {
          <a
            class="fs-6 text-light text-decoration-none"
            [href]="'#' + menu.toLowerCase()"
            >{{ menu }}</a
          >
        }
        <a
          href="https://dev.to/shreyaskar_18/how-to-generate-seo-meta-tags-open-graph-json-ld-free-tool-inside-11l3"
          target="_blank"
          rel="noopener noreferrer"
          class="fs-6 text-light text-decoration-none"
          >Blog</a
        >
        <a
          href="https://freeseogenerator.site"
          target="_blank"
          rel="noopener noreferrer"
          class="fs-6 text-light text-decoration-none"
          >Tools</a
        >
      </div>
      <img
        (click)="openCloseMenu()"
        [src]="
          '/assets/images/svg/' + (showMenu ? 'close' : 'hamburger') + '.svg'
        "
        class="d-block d-lg-none mob-menu"
        alt="hamburger"
        srcset=""
      />
    </div>
    @if (showMenu) {
      <div class="menu-overlay">
        <div class="sub-menu pull-left" [class]="{ open: openMenu }">
          <!--- menu links-->
          <div
            class="d-flex flex-column justify-content-start align-items-start w-100"
          >
            @for (menu of menus; track $index) {
              <a
                class="fs-6 text-light text-decoration-none"
                [href]="'#' + menu.toLowerCase()"
                (click)="openCloseMenu()"
                >{{ menu }}</a
              >
            }
            <a
              href="https://dev.to/shreyaskar_18/how-to-generate-seo-meta-tags-open-graph-json-ld-free-tool-inside-11l3"
              target="_blank"
              rel="noopener noreferrer"
              class="fs-6 text-light text-decoration-none"
              >Blog</a
            >
            <a
              href="https://freeseogenerator.site"
              target="_blank"
              rel="noopener noreferrer"
              class="fs-6 text-light text-decoration-none"
              >Tools</a
            >
          </div>

          <!--- social links --->

          <span
            class="social-wrap d-flex align-items-center justify-content-center"
          >
            <!-- <a *ngFor="let item of social" href="{{ item.link }}" target="_blank">
            <img src="{{ item.img }}" alt="{{ item.alt }}" loading="lazy" />
          </a> -->
          </span>

          <!---language dropdown-->
          <div class="btn-group language my-3" dropdown>
            <div
              dropdownToggle
              type="button"
              class="dropdown-toggle amountType d-flex align-items-center justify-content-between"
            >
              <!-- <div>
              <span class="ms-1 font-16 text-uppercase fw-semi-bold">{{
                selectedLanguage.value
              }}</span>
            </div> -->

              <!-- <svg-icon
              class="dropdown"
              src="./assets/images/svg-icons/down-arrow.svg"
              [svgStyle]="{ 'width.px': '20', 'height.px': '20' }"
            ></svg-icon> -->
            </div>

            <!-- <ul
            *dropdownMenu
            class="dropdown-menu dropdown-menu-left"
            role="menu"
          >
            <li
              class="p-2 cursor-pointer"
              role="menuitem"
              *ngFor="let lang of languagesList"
              (click)="changeLanguage(lang.value); openCloseMenu()"
            >
              <img
                src="./assets/images/flags/{{ lang.flag }}.svg"
                alt=""
                loading="lazy"
              />
              <span>{{ lang.native_name }}</span>
            </li>
          </ul> -->
          </div>
        </div>
      </div>
    }
  </div>
</header>
